import { Link } from '@reach/router'

export default Link
